import React, { useState, useEffect, useRef } from "react";
import "../css/bootstrap.min.css";
import "../css/font.css";
import "../css/login.css";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAuth } from "../context/AuthContext";

function Login() {
  const { user, login } = useAuth();
  
  const { social } = useParams(); // kakao | naver | undefined

  const hasCalledAPI = useRef(false);
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/", { replace: true });
    }
  }, [user, navigate]);

  // -------------------------------
  // 일반 로그인
  // -------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const res = await axios.post(
        "/api/auth/login_process",
        { id, password },
        { withCredentials: true }
      );
  
      if (res.data.success) {
        login(res.data.user); // ⭐ 핵심
        navigate("/", { replace: true });
      } else {
        setError(res.data.message || "로그인 실패");
      }
    } catch (err) {
      setError("서버 오류");
      console.error(err);
    }
  };
  

  // -------------------------------
  // Kakao 로그인 콜백 처리
  // -------------------------------
  useEffect(() => {
    if (social !== "kakao") return; // ✅ 추가

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    // code 없으면 일반 로그인 페이지
    if (!code || hasCalledAPI.current) return;

    hasCalledAPI.current = true;

    console.log("카카오 인가 코드 수신:", code);

    axios
      .post("/api/auth/kakao_callback", { code }, { withCredentials: true })
      .then((res) => {
        if (res.data.success) {
          login(res.data.user);

          // ✅ 네이티브 여기 추가
          window.ReactNativeWebView?.postMessage(
            JSON.stringify({ type: "LOGIN_SUCCESS" })
          );

          navigate("/", { replace: true });
        } else {
          setError("카카오 로그인 실패");
        }
      })
      .catch((err) => {
        console.error("카카오 로그인 에러:", err);
        setError("카카오 로그인 중 오류 발생");
      });
  }, [navigate, social]);

  // -------------------------------
  // 카카오 로그인 버튼
  // -------------------------------
  const handleKakaoLogin = async () => {
    const res = await axios.post(
      "/api/auth/kakao_login",
      {},
      { withCredentials: true }
    );
    window.location.href = res.data.auth_url;
  };

  // -------------------------------
  // Naver 로그인 처리
  // -------------------------------
  useEffect(() => {
    if (social !== "naver") return; // ✅ 추가

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
  
    if (code && state) {
      axios
        .post(
          "/api/auth/naver_callback",
          { code, state },
          { withCredentials: true }
        )
        .then((res) => {
          if (res.data.success) {
            login(res.data.user);

            // ✅ 네이티브 여기 추가
            window.ReactNativeWebView?.postMessage(
              JSON.stringify({ type: "LOGIN_SUCCESS" })
            );

            navigate("/", { replace: true });
          } else {
            setError("네이버 로그인 실패");
          }
        })
        .catch(() => {
          setError("네이버 로그인 오류");
        });
    }
  }, [navigate, social]);
  
  // -------------------------------
  // 네이버 로그인 버튼
  // -------------------------------
  const handleNaverLogin = async () => {
    const res = await axios.post(
      "/api/auth/naver_login?platform=web",
      {},
      { withCredentials: true }
    );
    window.location.href = res.data.auth_url;
  };

  return (
    <>
<div className="container py-4">
<div className="container-fluid p-0">
  <main className="col-md-12 bg-light">
    <div className="col-md-6 offset-md-3 p-2">
      <form className="p-4 p-md-5 border-0 rounded-3 bg-light needs-validation" onSubmit={handleSubmit} noValidate>
        

      {error && (
        <div className="alert alert-danger text-center">
          [{social ?? "normal"}] {error}
        </div>
      )}


        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="아이디"
            value={id}
            onChange={(e) => setId(e.target.value)}
            required
          />
          <label>아이디</label>
        </div>

        <div className="form-floating mb-3">
          <input
            type="password"
            className="form-control"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <label>패스워드</label>
        </div>

        <div className="checkbox mb-3 text-center">
          <label className="text-secondary">
            <input type="checkbox" value="remember-me" /> 로그인 상태 유지
          </label>
        </div>

        <button className="w-100 btn btn-lg btn-dark rounded-1 mb-4" type="submit">
          로그인
        </button>

        <hr className="my-4" />

        {/* 소셜 로그인 */}
        <div className="memLoginSocial">
          <ul>
            <li className="kakao js_btn_kakao_login" onClick={handleKakaoLogin}>
              <span className="kakaoIcon socialIcon">카카오 로그인</span>
            </li>

            <li className="naver js_btn_naver_login" onClick={handleNaverLogin}>
              <span className="naverIcon socialIcon">네이버 로그인</span>
            </li>

          </ul>
        </div>


        <div className="text-center mt-3">
          <Link to="/register"className="nav-link text-primary text-start">
            회원가입
          </Link>
        </div>
      </form>
    </div>
  </main>
</div>

</div>
</>
  );
}

export default Login;